module.exports = __webpack_public_path__ + "assets/TB-DB_icon_inventory_black_24dp.svg";